import { useState } from 'react'
import type { Dispatch, SetStateAction } from 'react'

/**
 * Bridges the gap between clearing a pending file and the data query delivering the new
 * URL. Without committed state, the preview flashes to the old URL or placeholder between
 * when the pending value is cleared and when the live query re-renders.
 *
 * Call `setCommittedUrl` after a successful upload (string URL) or delete (null). Pass
 * undefined to reset and fall back to liveUrl.
 */
export function useCommittedPreviewUrl(liveUrl: string | null): {
  resolvedUrl: string | null
  setCommittedUrl: Dispatch<SetStateAction<string | null | undefined>>
} {
  const [committedUrl, setCommittedUrl] = useState<string | null | undefined>(undefined)
  const resolvedUrl = committedUrl !== undefined ? committedUrl : liveUrl
  return { resolvedUrl, setCommittedUrl }
}
